import type {
  GetPromptsQuery,
  GetPromptsQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_PROMPTS: TypedDocumentNode<
  GetPromptsQuery,
  GetPromptsQueryVariables
> = gql`
  query GetPrompts {
    prompts {
      prompts {
        id
        value
        createdAt
        updatedAt
      }
    }
  }
`;
